export default __webpack_public_path__ + "static/tibet-d244b18413b9eaacf161305d2e84fa37.svg";